import { EnvironmentInjector, Injectable, Injector } from '@angular/core';
import { listAnimation, popoverController, PopoverOptions } from '@inscomponents/core';
import { FrameworkDelegate } from './framework-delegate.service';
import { OverlayBaseController } from './overlay';

@Injectable({providedIn: 'root'})
export class PopoverController extends OverlayBaseController<PopoverOptions, HTMLInsPopoverElement> {
    public constructor(
        private frameworkDelegate: FrameworkDelegate,
        private environmentInjector: EnvironmentInjector,
        private injector: Injector,
    ) {
        super(popoverController);
    }

    public override create(opts: PopoverOptions): Promise<HTMLInsPopoverElement> {
        const config = {
            enterAnimation: listAnimation.enterAnimation,
            leaveAnimation: listAnimation.leaveAnimation,
            ...opts,
        };
        return super.create({
            ...config,
            delegate: this.frameworkDelegate.create(this.environmentInjector, this.injector),
        });
    }
}
